import axios from 'axios';
//操作页面接口
export const getList = (params:any) => axios.post("operationLog/list", params);

export const operationLogAdd = (params:any) => axios.post("operationLog/add", params);

export const operationLogAccessSummary = (params:any) => axios.get("/operationLog/accessSummary", {params:params});

